/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Home_Hero_BadgeInputs */

const en_directory_home_hero_badge = /** @type {(inputs: Directory_Home_Hero_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} products launched on Seek AI`)
};

const zh_directory_home_hero_badge = /** @type {(inputs: Directory_Home_Hero_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已有 ${i?.count} 个产品在 Seek AI 发布`)
};

/**
* | output |
* | --- |
* | "{count} products launched on Seek AI" |
*
* @param {Directory_Home_Hero_BadgeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_badge = /** @type {((inputs: Directory_Home_Hero_BadgeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_BadgeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_badge(inputs)
	return zh_directory_home_hero_badge(inputs)
});
export { directory_home_hero_badge as "directory.home.hero.badge" }